module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column pointer"
  }, [_c('div', {
    staticClass: "flex flex-row tc flex items-center"
  }, [_c('input', {
    staticClass: "dn br3",
    attrs: {
      "id": "akkoPlan",
      "name": "planToggle",
      "type": "radio"
    },
    domProps: {
      "checked": !_vm.isPhoneOnly
    },
    on: {
      "input": _vm.setAkkoPlan
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "f7 inter pv2 tc b buttonUnselected left pointer",
    attrs: {
      "for": "akkoPlan",
      "tabindex": "0"
    }
  }, [_vm._v("\n      AKKO Plan\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "cera-round-pro color-gray mh2"
  }, [_vm._v("OR")]), _vm._v(" "), _c('input', {
    staticClass: "dn",
    attrs: {
      "id": "phonePlan",
      "name": "planToggle",
      "type": "radio"
    },
    domProps: {
      "checked": _vm.isPhoneOnly
    },
    on: {
      "input": _vm.setPhonePlan
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "f7 pv2 tc b buttonUnselected left pointer inter",
    attrs: {
      "for": "phonePlan",
      "tabindex": "0"
    }
  }, [_vm._v("\n      Phone Only\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a3ff520","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/PlanSelectToggle.vue
// module id = 765
// module chunks = 0